import { HttpErrorResponse } from '@angular/common/http';

export function toErrorTrace(error: unknown): Record<string, unknown> {
  if (error instanceof HttpErrorResponse) {
    const errorId =
      error.error && typeof error.error === 'object'
        ? (error.error as { errorId?: string }).errorId
        : undefined;

    return {
      status: error.status,
      statusText: error.statusText,
      url: error.url,
      message: error.message,
      errorId,
      error: error.error,
    };
  }

  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }

  return { error };
}
